interface GetBrowserLocalesOptions {
  languageCodeOnly?: boolean;
}

export const getBrowserLocales = (options: GetBrowserLocalesOptions = {}): string[] | undefined => {
  const defaultOptions: GetBrowserLocalesOptions = {
    languageCodeOnly: false,
  };

  const opt = {
    ...defaultOptions,
    ...options,
  };

  const browserLocales: readonly string[] =
    navigator.languages === undefined ? [navigator.language] : navigator.languages;

  if (!browserLocales) {
    return undefined;
  }

  const locales = browserLocales.map((locale: string) => {
    const trimmedLocale = locale.trim();
    return opt.languageCodeOnly ? trimmedLocale.split(/-|_/)[0] : trimmedLocale;
  });

  return [...new Set(locales)];
};
